<template>
  <nav :class="['navbar', {'white-bg': isWhite}]">
    <div class="nav">
      <div class="brand">
        <img src="../assets/logo2.png" alt="股励" class="logo" />
        <img src="../assets/split.png" alt="split" class="split" />
        <img src="../assets/slogan.png" alt="股励新财富" class="slogan" />
      </div>
      <ul class="nav-list">
        <li @click="toIndex()" :class="[{'active': active=='index'}]">首页</li>
        <li @click="toAbout()" :class="[{'active': active=='about'}]">联系我们</li>
        <li @click="toSaaS()">股励SaaS</li>
        <li @click="toAI()">股励AI</li>
      </ul>
      <img src="../assets/menu.png" class="menu" @click="toggle()" />
    </div>
    <div class="drop-menu" v-if="dropShow">
      <ul>
        <li @click="toIndex()">首页</li>
        <li @click="toAbout()">联系我们</li>
        <li @click="toSaaS()">股励SaaS</li>
        <li @click="toAI()">股励AI</li>
      </ul>
    </div>
  </nav>
</template>
<script>
import http from 'axios'
export default {
  data() {
    return {
      dropShow: false,
      isWhite: false
    }
  },
  mounted() {
    document.addEventListener('scroll', e => {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        0
      if (scrollTop > 5) {
        this.isWhite = true
      } else {
        this.isWhite = false
      }
    })
  },
  props: {
    active: String
  },
  methods: {
    toggle() {
      this.dropShow = !this.dropShow
    },
    toIndex() {
      window.location.href = './index.html'
    },
    toAbout() {
      window.location.href = './about.html'
    },
    toSaaS() {
      window.open('http://51guli.com/erp/index.action')
    },
    toAI() {
      setTimeout(() => {
        let browser = this.getExploreName()
        http.get(`//api.51guli.com/ip?browser=${browser}`)
      }, 500)
      window.open('http://hi.guli.ai')
    },
    getExploreName() {
      var userAgent = navigator.userAgent
      if (userAgent.indexOf('Opera') > -1 || userAgent.indexOf('OPR') > -1) {
        return 'Opera'
      } else if (
        userAgent.indexOf('compatible') > -1 &&
        userAgent.indexOf('MSIE') > -1
      ) {
        return 'IE'
      } else if (userAgent.indexOf('Edge') > -1) {
        return 'Edge'
      } else if (userAgent.indexOf('Firefox') > -1) {
        return 'Firefox'
      } else if (
        userAgent.indexOf('Safari') > -1 &&
        userAgent.indexOf('Chrome') == -1
      ) {
        return 'Safari'
      } else if (
        userAgent.indexOf('Chrome') > -1 &&
        userAgent.indexOf('Safari') > -1
      ) {
        return 'Chrome'
      } else if (!!window.ActiveXObject || 'ActiveXObject' in window) {
        return 'IE>=11'
      } else {
        return 'Unkonwn'
      }
    }
  }
}
</script>

<style lang="postcss">
.navbar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 90px;
  background: #f7f7f7;
  margin: 0;
  border-radius: 0;
  border: none;
  z-index: 1000;
}
.white-bg {
  background: #ffffff;
}
.nav {
  width: 1200px;
  margin: auto;
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.brand {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  height: 100%;
}
.logo {
  display: inline-block;
  height: 50px;
}
.split {
  display: inline-block;
  height: 43px;
  margin: 0 12px;
}
.slogan {
  display: inline-block;
  height: 19px;
}
.menu {
  display: none;
}
.drop-menu ul {
  display: none;
}
.nav-list {
  display: flex;
  height: 100%;
  flex-direction: row;
  align-items: center;
}
.nav-list li {
  margin: 0 30px;
  color: #333333;
  font-size: 16px;
  border-bottom: 2px solid transparent;
  padding: 4px;
  cursor: pointer;
}
.nav-list li.active {
  color: #d09863;
  border-bottom: 2px solid #d09863;
}
@media (max-width: 1200px) {
  .split {
    display: none;
  }
  .slogan {
    display: none;
  }
  .navbar {
    height: 56px;
  }
  .nav {
    width: 100%;
    align-items: center;
  }
  .logo {
    height: 35px;
    margin-left: 20px;
  }
  .nav-list {
    display: none;
  }
  .menu {
    display: inline-block;
    margin-right: 20px;
    width: 30px;
    height: 20px;
    line-height: 56px;
  }
  .container {
    margin-top: 56px;
  }
  .drop-menu {
    width: 100%;
    background: #ffffff;
  }
  .drop-menu ul {
    display: block;
    background-color: #fefefe;
  }
  .drop-menu li {
    color: #c5aa6f;
    text-align: center;
    font-size: 18px;
    line-height: 40px;
    border-bottom: #d6d6d6 solid 0.5px;
  }
  .drop-menu li:last-child {
    border-bottom: none;
  }
}
@media (max-width: 580px) {
  .split {
    display: none;
  }
  .slogan {
    display: none;
  }
  .navbar {
    height: 56px;
  }
  .nav {
    width: 100%;
    align-items: center;
  }
  .logo {
    height: 35px;
    margin-left: 20px;
  }
  .nav-list {
    display: none;
  }
  .menu {
    display: inline-block;
    margin-right: 20px;
    width: 30px;
    height: 20px;
    line-height: 56px;
  }
  .container {
    margin-top: 56px;
  }
}
</style>